import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from '@xstyled/styled-components';
import { Button, Tooltip } from 'antd';
import { DefaultLink, getSize } from '@lib/common';
import { getTranslatedTypeName } from '@module/assignment';
import { AssignmentStatusComponent, getDateTime, getTranslatedStatusName } from '../utils';
import { EyeOutlined, ShareAltOutlined } from '@ant-design/icons';
import { AssignmentTypeTag } from '../assignment-type-tag.component';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledGroupAction = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  gap: ", ";\n  justify-content: space-around;\n  white-space: nowrap;\n  a {\n    font-size: 16px;\n    text-align: center;\n  }\n"])), getSize('gap8'));
export var renderAssignmentTableColumns = function renderAssignmentTableColumns(props) {
  var handleShare = props.handleShare,
      navigateToAssignmentDetail = props.navigateToAssignmentDetail,
      tableAssignmentTranslation = props.tableAssignmentTranslation;
  return [{
    title: "".concat(tableAssignmentTranslation.idNumber),
    width: '8%',
    dataIndex: 'idNumber',
    key: 'idNumber',
    render: function render(_, record) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: tableAssignmentTranslation.clickToViewDetail,
        children: /*#__PURE__*/_jsxs(DefaultLink, {
          onClick: function onClick() {
            return navigateToAssignmentDetail(record.id.toString());
          },
          children: ["#", record.idNumber]
        })
      });
    }
  }, {
    title: "".concat(tableAssignmentTranslation.title),
    width: '14%',
    dataIndex: 'title',
    key: 'title',
    sorter: {
      compare: function compare(a, b) {
        var _a$title;

        return (_a$title = a.title) === null || _a$title === void 0 ? void 0 : _a$title.localeCompare(b.title);
      }
    },
    render: function render(_, record) {
      return /*#__PURE__*/_jsx("span", {
        children: record.title
      });
    }
  }, {
    title: "".concat(tableAssignmentTranslation.typeTest),
    width: '11%',
    dataIndex: 'type',
    key: 'type',
    sorter: {
      compare: function compare(a, b) {
        var _a$type;

        return (_a$type = a.type) === null || _a$type === void 0 ? void 0 : _a$type.name.localeCompare(b.type.name);
      }
    },
    render: function render(_, record) {
      return /*#__PURE__*/_jsx(AssignmentTypeTag, {
        typeId: record.type.id,
        typeName: getTranslatedTypeName(record.type.id, record.type.name, tableAssignmentTranslation)
      });
    }
  }, {
    title: "".concat(tableAssignmentTranslation.status),
    width: '12%',
    dataIndex: 'status',
    key: 'status',
    render: function render(_, record) {
      return /*#__PURE__*/_jsx(AssignmentStatusComponent, {
        statusType: record.displayStatus.value,
        text: getTranslatedStatusName(record.displayStatus.value, tableAssignmentTranslation)
      });
    }
  }, {
    title: "".concat(tableAssignmentTranslation.durationAssignment),
    width: '12%',
    dataIndex: 'duration',
    key: 'duration',
    render: function render(_, record) {
      return /*#__PURE__*/_jsx("span", {
        children: record.duration != null ? "".concat(record.duration, " ").concat(tableAssignmentTranslation.minute) : '—'
      });
    }
  }, {
    title: "".concat(tableAssignmentTranslation.startEndDate),
    width: '15%',
    key: 'date',
    render: function render(_, record) {
      return /*#__PURE__*/_jsxs("span", {
        children: [record.startTime ? getDateTime(+record.startTime) : '-', /*#__PURE__*/_jsx("br", {}), record.endTime ? getDateTime(+record.endTime) : null]
      });
    }
  }, {
    title: "".concat(tableAssignmentTranslation.totalAttendee),
    width: '9%',
    dataIndex: 'totalAttendee',
    key: 'totalAttendee'
  }, {
    width: '7%',
    key: 'action',
    render: function render(_, record) {
      return /*#__PURE__*/_jsxs(StyledGroupAction, {
        children: [/*#__PURE__*/_jsx(Button, {
          type: "text",
          onClick: function onClick() {
            return navigateToAssignmentDetail(record.id.toString());
          },
          children: /*#__PURE__*/_jsx(Tooltip, {
            title: "".concat(tableAssignmentTranslation.clickToViewDetail),
            children: /*#__PURE__*/_jsx(EyeOutlined, {})
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "text",
          onClick: function onClick() {
            return handleShare(record.id.toString(), record.title, record.idNumber);
          },
          children: /*#__PURE__*/_jsx(Tooltip, {
            title: "".concat(tableAssignmentTranslation.share),
            children: /*#__PURE__*/_jsx(ShareAltOutlined, {})
          })
        })]
      });
    }
  }];
};